<div class="card subscribe-card">
    <div class="content-container">
        <div class="content card-content-centered">
            <div class="card-header h1-text" translate>{{title}}</div>
            <div class="card-text field" translate>{{content}}</div>
            <div class="card-text field">
                <a class="btn btn_primary btn_link" translate (click)="gotoEmailPreferences()">unsubscribe.Manage email preferences</a>
            </div>
        </div>
    </div>
</div>
